module.exports = __webpack_public_path__ + "img/icon-contact-us.32ee1fd.png";